export const Admin = {
    user_admin: "admin@mymoons.mx"
}


// WEBPACK FOOTER //
// ./src/configurations/Admin.js